export default __webpack_public_path__ + "static/media/can_yetismis_cv.659d979a.pdf";